class VideoPreviewLimit {
  constructor() {
    this.init();
  }

  init() {
    // Procura por vídeos de preview locais
    const previewVideos = document.querySelectorAll('video[data-video-preview="true"]');
    
    previewVideos.forEach(video => {
      // Verifica se o vídeo tem duração definida
      const duration = video.getAttribute('data-preview-duration');
      if (duration) {
        // Adiciona evento para monitorar o tempo de reprodução
        video.addEventListener('timeupdate', () => {
          if (video.currentTime >= parseInt(duration, 10)) {
            // Reinicia o vídeo quando atingir o limite
            video.currentTime = 0;
          }
        });
      }
    });
  }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VideoPreviewLimit());
} else {
  new VideoPreviewLimit();
}
